"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UnderlinedButton = exports.SecondaryButton = exports.PrimaryButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttonModule = _interopRequireDefault(require("./button.module.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Button = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Button, _PureComponent);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    (0, _classCallCheck2["default"])(this, Button);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTouchStart", function () {
      // eslint-disable-next-line
      var onTouchStart = _this.props.onTouchStart;

      _this.setState({
        touched: true
      });

      if (onTouchStart) {
        onTouchStart();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeave", function () {
      // eslint-disable-next-line
      var onMouseLeave = _this.props.onMouseLeave;

      _this.setState({
        touched: false
      });

      if (onMouseLeave) {
        onMouseLeave();
      }
    });
    _this.state = {
      touched: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          tag = _this$props.tag,
          children = _this$props.children,
          className = _this$props.className,
          type = _this$props.type,
          level = _this$props.level,
          size = _this$props.size,
          disabled = _this$props.disabled,
          inverted = _this$props.inverted,
          submitting = _this$props.submitting,
          inline = _this$props.inline,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["tag", "children", "className", "type", "level", "size", "disabled", "inverted", "submitting", "inline"]);
      var touched = this.state.touched;
      var classes = (0, _classnames["default"])(_buttonModule["default"]['c-button'], (_classNames = {}, (0, _defineProperty2["default"])(_classNames, _buttonModule["default"]["c-button--".concat(level)], !!level), (0, _defineProperty2["default"])(_classNames, _buttonModule["default"]['c-button--inverted'], inverted), (0, _defineProperty2["default"])(_classNames, _buttonModule["default"]['c-button--disabled'], disabled || submitting), (0, _defineProperty2["default"])(_classNames, _buttonModule["default"]['c-button--submitting'], submitting), (0, _defineProperty2["default"])(_classNames, _buttonModule["default"]['c-button--inline'], inline), (0, _defineProperty2["default"])(_classNames, _buttonModule["default"]['c-button--small'], size === 'small'), (0, _defineProperty2["default"])(_classNames, 'jl-touched', touched), _classNames), (0, _defineProperty2["default"])({}, _buttonModule["default"][className], !!_buttonModule["default"][className]), (0, _defineProperty2["default"])({}, className, !_buttonModule["default"][className] && !!className));
      return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread({}, rest), {}, {
        type: tag === 'button' ? type : undefined,
        className: classes,
        disabled: tag === 'button' ? disabled || submitting : undefined,
        onTouchStart: this.onTouchStart,
        onMouseLeave: this.onMouseLeave
      }), !submitting ? children : /*#__PURE__*/_react["default"].createElement("span", {
        className: "hidden"
      }, children));
    }
  }]);
  return Button;
}(_react.PureComponent);

(0, _defineProperty2["default"])(Button, "propTypes", {
  /** what tag to render (button/a/Link etc.) */
  tag: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),

  /** button value, usually just plain text */
  children: _propTypes["default"].node,

  /** additional class passed to button */
  className: _propTypes["default"].string,

  /** choose type of button (submit || reset) */
  type: _propTypes["default"].string,

  /** type of button (primary || secondary) */
  level: _propTypes["default"].string,

  /** change size of button */
  size: _propTypes["default"].string,

  /** put button in disabled state */
  disabled: _propTypes["default"].bool,

  /** display the button on a dark background */
  inverted: _propTypes["default"].bool,

  /** put button in submitting state */
  submitting: _propTypes["default"].bool,

  /** display the button in a natural width for showing inline with others */
  inline: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Button, "defaultProps", {
  tag: 'button',
  children: '',
  className: undefined,
  type: 'button',
  level: undefined,
  size: undefined,
  disabled: false,
  inverted: false,
  submitting: false,
  inline: false
});

var PrimaryButton = function PrimaryButton(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(Button, (0, _extends2["default"])({
    level: "primary"
  }, rest), children);
};

exports.PrimaryButton = PrimaryButton;

var SecondaryButton = function SecondaryButton(_ref2) {
  var children = _ref2.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(Button, (0, _extends2["default"])({
    level: "secondary"
  }, rest), children);
};

exports.SecondaryButton = SecondaryButton;

var UnderlinedButton = function UnderlinedButton(_ref3) {
  var children = _ref3.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref3, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(Button, (0, _extends2["default"])({
    level: "underlined"
  }, rest), children);
};

exports.UnderlinedButton = UnderlinedButton;
var _default = Button;
exports["default"] = _default;